import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Testimonial1 as Block } from "./Testimonial1";
import { defaultData } from "./Testimonial1DefaultData";
import imagePreview from "./testimonial-1-preview.png";

export const Testimonial1Block: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Testimonial 1",
    version: 1,
    nameI18n: "builder_ui.block_type.testimonial_1",
    isHidden: true,
    props: {
      userCard: {
        name: "User Card",
        nameI18n: "builder_ui.prop_type.user_card",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
  },
};
